export default __webpack_public_path__ + "static/media/Picture1 2.e722803b.svg";